import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useApi } from "@/";

const Amazon = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { callApi, loading } = useApi();
  useEffect(() => {
    const handleAmazonCallback = async () => {
      try {
        // Get query parameters from URL
        const params = new URLSearchParams(location.search);
        const spapi_oauth_code = params.get("spapi_oauth_code");
        const selling_partner_id = params.get("selling_partner_id");
        const state = params.get("state");

        if (spapi_oauth_code && selling_partner_id) {
          // Send the data to your backend
          const response = await callApi("/user/addAmazon", "POST", {
            spapi_oauth_code,
            selling_partner_id,
            state,
          });

          if (response.data.success) {
            // Redirect to settings/channel page after successful integration
            navigate("/settings/channel", {
              state: {
                success: true,
                message: "Amazon account connected successfully",
              },
            });
          }
        }
      } catch (error) {
        console.error("Error connecting Amazon account:", error);
        navigate("/settings/channel", {
          state: {
            success: false,
            message: "Failed to connect Amazon account",
          },
        });
      }
    };

    handleAmazonCallback();
  }, [navigate, location]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h2 className="text-xl font-semibold mb-4">
          Connecting your Amazon account...
        </h2>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
      </div>
    </div>
  );
};

export default Amazon;
